export type ChapterId =
  | 'prologue'
  | 'planet'
  | 'descent'
  | 'fire'
  | 'morph'
  | 'watch'
  | 'civilization'
  | 'finale';

export interface StoryChapter {
  id: ChapterId;
  eyebrow?: string;
  title: string;
  body?: string;
  start: number;
  end: number;
  align?: 'left' | 'center' | 'right';
}

export const chapters: StoryChapter[] = [
  {
    id: 'prologue',
    title: 'Every civilization begins with a choice.',
    start: 0,
    end: 0.1,
    align: 'center',
  },
  {
    id: 'planet',
    eyebrow: 'I · BEFORE DIRECTION',
    title: 'A world inherited time before it understood direction.',
    start: 0.1,
    end: 0.28,
    align: 'left',
  },
  {
    id: 'descent',
    eyebrow: 'II · THE DESCENT',
    title: 'The camera does not cut. It enters the world it has watched form.',
    start: 0.28,
    end: 0.4,
    align: 'right',
  },
  {
    id: 'fire',
    eyebrow: 'III · THE FIRST DECISION',
    title: 'Civilization did not begin with power.',
    body: 'It began when someone chose to make fire.',
    start: 0.4,
    end: 0.53,
    align: 'left',
  },
  {
    id: 'morph',
    eyebrow: 'IV · WHAT WE CARRY',
    title: 'Vine becomes cord. Cord becomes leather. Craft becomes memory.',
    start: 0.53,
    end: 0.67,
    align: 'right',
  },
  {
    id: 'watch',
    eyebrow: 'V · ANNV',
    title: 'Time begins to move only after direction is chosen.',
    start: 0.67,
    end: 0.82,
    align: 'left',
  },
  {
    id: 'civilization',
    eyebrow: 'VI · CONTINUATION',
    title: 'Ordinary people continue what the first maker began.',
    start: 0.82,
    end: 0.93,
    align: 'right',
  },
  {
    id: 'finale',
    title: 'TIME IS INHERITED.\nDIRECTION IS CHOSEN.',
    start: 0.93,
    end: 1,
    align: 'center',
  },
];
